import Home from "../views/Home";
import Locations from "../views/location/Locations";

export default [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/locations',
        name: 'Locations',
        component: Locations
    }
]
